module.exports = require('./helpers/bundle-url').getBundleURL('5C5nw') + "logo-dark.eefe0b7f.svg";